module.exports = __webpack_public_path__ + "img/welcome.eaad949e.png";